export default __webpack_public_path__ + "static/media/placeholder.ef39ee0b.svg";